import THGTracker from '../../tracking/thg/THGTracker';
import Track from '../utils/tracking';
import device from './device';
import JsonHelper from './jsonHelper';

class BigQueryPageViewRecorder {
  isEnabled = () => {
    const {settings} = window.start;
    if (settings.checkout_tracking_url && settings.checkout_conversion_tracking_enabled) {
      this.url = settings.checkout_tracking_url;
      return true;
    }
    return false;
  };
  
  getEventData = () => {
    const deviceInfo = device.getType();
    
    const getDeviceType = () => {
      if (deviceInfo.is_pc) {
        return 'desktop';
      }
      if (deviceInfo.is_mobile) {
        return 'mobile';
      }
      if (deviceInfo.is_app) {
        return 'app';
      }
      
      return 'tablet';
    };
    
    const getCustomerType = () => {
      if (window.start.guestCheckout) {
        return 'guest';
      }
      
      if (window.start.customer?.newCustomer) {
        return 'new';
      }
      
      return 'returning';
    };
    
    const getChumeweUserCookie = () => {
      return device.getDeviceData().device.cookie;
    }
    
    const getChumeweSessionCookie = () => {
      return device.getDeviceData().device.sess_cookie;
    }
    
    const baseProperties = [
      {timestamp: window.start.timeStamp},
      {orderNumber: window.start.orderNumber},
      {customerId: window.start.customer?.customerId},
      {customerType: getCustomerType()},
      {siteId: window.start.siteDataV2?.siteId},
      {siteCode: window.start.siteDataV2?.siteCode},
      {locale: window.start.siteDataV2?.locale},
      {currency: window.start.orderTotal?.currencyCode},
      {os: deviceInfo?.family},
      {device: getDeviceType()},
      {browser: device.getBrowserData()?.family},
      {userAgent: window.navigator?.userAgent},
    ];
    
    // Add chumwe cookie attributes if the setting is enabled
    if (window.start.settings?.enable_chumwe_cookie_attributes_for_conversion_tracking) {
      baseProperties.push(
        {chumeweUser: getChumeweUserCookie()},
        {chumeweSess: getChumeweSessionCookie()}
      );
    }
    
    return JsonHelper.getJsonMessage(...baseProperties);
  };
  
  sendMetric = () => new Promise((resolve) => {
    if (this.isEnabled()) {
      THGTracker.sendConversionTables(this.url, this.getEventData(), 'checkoutPageView');
    }
    resolve();
  })
    .catch((error) => {
      Track.track(`Failed to send conversion data to big query. ${error}`);
    });
}

export default () => new BigQueryPageViewRecorder().sendMetric();
